import { getSourceTypeForMailboxInfo } from 'owa-account-source-list';
import { AccountSourceType } from 'owa-account-source-list-types';
import type { MailboxInfo } from 'owa-client-types';
import { isAccountFeatureEnabled } from 'owa-feature-flags';
import type { SearchTableQuery } from 'owa-mail-list-search';
import { SearchProvider, SearchScopeKind } from 'owa-search-service';
import { SearchTab } from 'owa-search-types/lib/types/SearchTab';

/**
 * Determines whether interleaved search is selected for the given query and mailbox.
 *
 * @param searchTableQuery - Query whose provider, tab, scenario, and scope must support interleaving.
 * @param mailboxInfo - Mailbox whose account type and feature state are evaluated.
 * @returns `true` when the interleaved search scope is selected.
 */
export function getIsInterleavingSearchScopeSelected(
    searchTableQuery: SearchTableQuery,
    mailboxInfo: MailboxInfo
): boolean {
    if (
        !isAccountFeatureEnabled('sea-gmailOutlookSearchInterleaving', mailboxInfo) ||
        getSourceTypeForMailboxInfo(mailboxInfo) !== AccountSourceType.Google
    ) {
        return false;
    }

    const isSupportedProvider =
        searchTableQuery.searchProvider === SearchProvider.Substrate ||
        searchTableQuery.searchProvider === SearchProvider.SubstrateV2;

    const isSupportedTab =
        searchTableQuery.searchTab === undefined ||
        searchTableQuery.searchTab === SearchTab.Mail ||
        searchTableQuery.searchTab === SearchTab.All;

    return (
        isSupportedProvider &&
        isSupportedTab &&
        searchTableQuery.scenarioType === 'mail' &&
        searchTableQuery.searchScope.kind === SearchScopeKind.PrimaryMailbox
    );
}
